<template>
  <div class="modal-vue rfp-mctb-commerceConnector -expanded">
    <div class="rfp-mctb-commerceConnector__overlay" @click="switchPanel(false)"></div>
    <div
      class="modal-vue--content"
      :class="[
        {
          'rfp-mctb-commerceConnector__layout-top': popupDirection === 'top',
          'rfp-mctb-commerceConnector__layout-bottom': popupDirection === 'bottom',
          'rfp-mctb-commerceConnector__layout-left': popupDirection === 'left',
          'rfp-mctb-commerceConnector__layout-right': popupDirection === 'right',
        },
      ]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-heading"
    >
      <form>
        <div
          class="modal-vue--content-panel"
          :class="[
            {
              'rfp-mctb-commerceConnector__wrapper-top-bottom':
                popupDirection === 'top' || popupDirection === 'bottom',
              'rfp-mctb-commerceConnector__wrapper':
                popupDirection === 'right' || popupDirection === 'left',
            },
          ]"
        >
          <span
            class="rfp-mctb-commerceConnector__close rfp-mctb-commerceConnector__tabIndex"
            @click="switchPanel(false)"
          >
            X
          </span>
          <div
            v-if="commerceData.Product.Retailers.length === 0"
            class="rfp-mctb-commerceConnector__description"
            style="height: 100%"
          >
            <span
              id=""
              style="
                font-size: 2em;
                margin-block-start: 0.67em;
                margin-block-end: 0.67em;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                font-weight: bold;
              "
            >
              <strong class="rfp-mctb__005__header">{{ retailerUnavailable }}</strong>
            </span>
          </div>
          <fieldset v-else class="vue-tabs">
            <legend class="rfp-mctb-commerceConnector__description">
              <h1 id="modal-heading">
                <strong v-if="commerceData.Product.BrandTitle != ''" class="rfp-mctb__001__header"
                  >{{ commerceData.Product.BrandTitle }} -
                </strong>
                <strong
                  v-if="commerceData.Product.SubBrandTitle != ''"
                  class="rfp-mctb__002__header"
                  >{{ commerceData.Product.SubBrandTitle }} -
                </strong>
                <strong v-if="commerceData.Product.Title != ''" class="rfp-mctb__003__header"
                  >{{ commerceData.Product.Title }} -
                </strong>
                <strong class="rfp-mctb__004__header"> {{ headerText }} </strong>
              </h1>
            </legend>

            <div
              v-if="commerceData.CountryList.length != 0"
              class="_rfp_mctb_list_006_ nav-tabs-navigation"
            >
              <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
                <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
                  <li
                    v-for="(x, index) in commerceData.CountryList"
                    :id="x.DisplayName"
                    :key="x.DisplayName"
                    name="tab"
                    aria-selected="true"
                    :aria-controls="x.DisplayName"
                    role="tab"
                    class="_rfp_mctb_list_009_ tab active"
                    :class="{ active__tab: index === tabIndex }"
                    @click="tabEnable(x, index)"
                  >
                    <span role="tab" class="_rfp_mctb_list_0010_ active_tab tabs__link">
                      <span class="_rfp_mctb_list_0011_ title title_center">
                        {{ x.DisplayName }}
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <template v-if="enableBuynowRetailers && commerceData.CountryList.length != 0">
              <template v-for="(x, index) in commerceData.CountryList">
                <section
                  v-if="index === tabIndex && x.Name === tabValue.Name"
                  :id="x.Name"
                  :key="x.Name"
                  :aria-labelledby="x.Name"
                  role="tabpanel"
                  class="_rfp_mctb_list_0018_ tab-container"
                >
                  <ul
                    class="ifpath"
                    :class="{
                      'rfp-mctb-commerceConnector__shops':
                        popupDirection === 'right' || popupDirection === 'left',
                      'rfp-mctb-commerceConnector__shops__top__bottom':
                        popupDirection === 'top' || popupDirection === 'bottom',
                    }"
                  >
                    <template v-for="shopData in commerceData.Product.Retailers">
                      <li
                        v-if="shopData.Country === x.Name"
                        :key="shopData.RetailerItemId"
                        class="rfp-mctb-commerceConnector__item"
                      >
                        <input
                          :id="shopData.RetailerItemId"
                          class="isSrOnly rfp-mctb-commerceConnector__radioButton rfp-mctb-commerceConnector__tabIndex"
                          type="radio"
                          name="retailer"
                          :value="shopData.Name"
                          @focus="
                            pageRedirectUrl(
                              shopData.RetailerUrl,
                              shopData.OpenInNewWindow,
                              shopData.RetailerTags,
                              shopData.RetailerTagsGS,
                              shopData.Name,
                            )
                          "
                        />
                        <label
                          class="rfp-mctb-commerceConnector__radioLabel"
                          :for="shopData.RetailerItemId"
                          @click="
                            pageRedirectUrl(
                              shopData.RetailerUrl,
                              shopData.OpenInNewWindow,
                              shopData.RetailerTags,
                              shopData.RetailerTagsGS,
                              shopData.Name,
                            )
                          "
                        >
                          <img
                            class="rfp-mctb-commerceConnector__logo"
                            :src="shopData.Logo"
                            :alt="shopData.LogoAlt"
                          />
                          <span
                            class="rfp-mctb-commerceConnector-retailer-desc"
                            v-html="shopData.Description"
                          ></span>
                        </label>
                      </li>
                    </template>
                    <li v-if="tabRetailerList.length === 0">
                      <div class="retailer-unavailable_03 1">
                        {{ retailerUnavailable }}
                      </div>
                    </li>
                  </ul>
                </section>
              </template>
            </template>
            <template v-if="!enableBuynowRetailers && commerceData.CountryList.length != 0">
              <template v-for="(x, index) in commerceData.CountryList">
                <section
                  v-if="index === tabIndex && x.Name === tabValue.Name"
                  :id="x.Name"
                  :key="x.Name"
                  :aria-labelledby="x.Name"
                  role="tabpanel"
                  class="_rfp_mctb_list_0018_ tab-container"
                >
                  <ul
                    class="elsepath"
                    :class="{
                      'rfp-mctb-commerceConnector__shops':
                        popupDirection === 'right' || popupDirection === 'left',
                      'rfp-mctb-commerceConnector__shops__top__bottom':
                        popupDirection === 'top' || popupDirection === 'bottom',
                    }"
                  >
                    <template v-for="shopData in commerceData.Product.Retailers">
                      <li
                        v-if="shopData.Country === x.Name"
                        :key="shopData.RetailerItemId"
                        class="rfp-mctb-commerceConnector__item"
                      >
                        <input
                          :id="shopData.RetailerItemId"
                          class="isSrOnly rfp-mctb-commerceConnector__radioButton rfp-mctb-commerceConnector__tabIndex"
                          type="radio"
                          name="retailer"
                          :value="shopData.Name"
                        />
                        <label
                          :for="shopData.RetailerItemId"
                          class="rfp-mctb-commerceConnector__radioLabel"
                          @click="
                            pageRedirectUrl(
                              shopData.RetailerUrl,
                              shopData.OpenInNewWindow,
                              shopData.RetailerTags,
                              shopData.RetailerTagsGS,
                              shopData.Name,
                              'welcome',
                            )
                          "
                        >
                          <img
                            class="rfp-mctb-commerceConnector__logo"
                            :src="shopData.Logo"
                            :alt="shopData.LogoAlt"
                          />
                          <span
                            class="rfp-mctb-commerceConnector-retailer-desc"
                            v-html="shopData.Description"
                          ></span>
                        </label>
                      </li>
                    </template>
                    <li v-if="tabRetailerList.length === 0">
                      <div class="retailer-unavailable_03 2">
                        {{ retailerUnavailable }}
                      </div>
                    </li>
                  </ul>
                </section>
              </template>
            </template>
            <template v-if="enableBuynowRetailers && commerceData.CountryList.length === 0">
              <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
                <ul
                  class="ifpath"
                  :class="{
                    'rfp-mctb-commerceConnector__shops':
                      popupDirection === 'right' || popupDirection === 'left',
                    'rfp-mctb-commerceConnector__shops__top__bottom':
                      popupDirection === 'top' || popupDirection === 'bottom',
                  }"
                >
                  <li
                    v-for="shopData in commerceData.Product.Retailers"
                    :key="shopData.RetailerItemId"
                    class="rfp-mctb-commerceConnector__item"
                  >
                    <input
                      :id="shopData.RetailerItemId"
                      class="isSrOnly rfp-mctb-commerceConnector__radioButton rfp-mctb-commerceConnector__tabIndex"
                      type="radio"
                      name="retailer"
                      :value="shopData.Name"
                      @focus="
                        pageRedirectUrl(
                          shopData.RetailerUrl,
                          shopData.OpenInNewWindow,
                          shopData.RetailerTags,
                          shopData.RetailerTagsGS,
                          shopData.Name,
                        )
                      "
                    />
                    <label
                      class="rfp-mctb-commerceConnector__radioLabel"
                      :for="shopData.RetailerItemId"
                      @click="
                        pageRedirectUrl(
                          shopData.RetailerUrl,
                          shopData.OpenInNewWindow,
                          shopData.RetailerTags,
                          shopData.RetailerTagsGS,
                          shopData.Name,
                        )
                      "
                    >
                      <img
                        class="rfp-mctb-commerceConnector__logo"
                        :src="shopData.Logo"
                        :alt="shopData.LogoAlt"
                      />
                      <span
                        class="rfp-mctb-commerceConnector-retailer-desc"
                        v-html="shopData.Description"
                      ></span>
                    </label>
                  </li>
                  <li v-if="commerceData.Product.Retailers.length === 0">
                    <div class="retailer-unavailable_03 3">
                      {{ retailerUnavailable }}
                    </div>
                  </li>
                </ul>
              </section>
            </template>
            <template v-if="!enableBuynowRetailers && commerceData.CountryList.length === 0">
              <section role="tabpanel" class="_rfp_mctb_list_0018_ tab-container">
                <ul
                  class="elsepath"
                  :class="{
                    'rfp-mctb-commerceConnector__shops':
                      popupDirection === 'right' || popupDirection === 'left',
                    'rfp-mctb-commerceConnector__shops__top__bottom':
                      popupDirection === 'top' || popupDirection === 'bottom',
                  }"
                >
                  <li
                    v-for="shopData in commerceData.Product.Retailers"
                    :key="shopData.RetailerItemId"
                    class="rfp-mctb-commerceConnector__item"
                  >
                    <input
                      :id="shopData.RetailerItemId"
                      class="isSrOnly rfp-mctb-commerceConnector__radioButton rfp-mctb-commerceConnector__tabIndex"
                      type="radio"
                      name="retailer"
                      :value="shopData.Name"
                    />
                    <label
                      :for="shopData.RetailerItemId"
                      class="rfp-mctb-commerceConnector__radioLabel"
                      @click="
                        pageRedirectUrl(
                          shopData.RetailerUrl,
                          shopData.OpenInNewWindow,
                          shopData.RetailerTags,
                          shopData.RetailerTagsGS,
                          shopData.Name,
                          'welcome',
                        )
                      "
                    >
                      <img
                        class="rfp-mctb-commerceConnector__logo"
                        :src="shopData.Logo"
                        :alt="shopData.LogoAlt"
                      />
                      <span
                        class="rfp-mctb-commerceConnector-retailer-desc"
                        v-html="shopData.Description"
                      ></span>
                    </label>
                  </li>
                  <li v-if="commerceData.Product.Retailers.length === 0">
                    <div class="retailer-unavailable_03 4">
                      {{ retailerUnavailable }}
                    </div>
                  </li>
                </ul>
              </section>
            </template>

            <div
              v-if="
                enableBuynowRetailers &&
                ((commerceData.CountryList.length === 0 &&
                  commerceData.Product.Retailers.length != 0) ||
                  (commerceData.CountryList.length != 0 && tabRetailerList.length != 0))
              "
              class="rfp-mctb-commerceConnector__cta"
            >
              <button
                data-tag-wrapper
                class="button -primaryAnimated rfp-mctb-commerceConnector__tabIndex"
                @click="buyNowRetailers"
              >
                <span>{{ buyMessage }}</span>
              </button>
            </div>
          </fieldset>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-pop-up-action-mode',
  props: {
    initialData: {
      type: Object,
      required: true,
    },
    closeIconText: {
      type: String,
      required: false,
      default: 'Close',
    },
    popupDirection: {
      type: String,
      default: 'left',
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    headerText: {
      type: String,
      default: 'Carousel Header',
    },
    enableBuynowRetailers: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
    initialExtraParams: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      shopData: {},
      commerceData: this.initialData,
      expandPanel: false,
      buyMessage: 'Buynow',
      taggingAction: '',
      taggingLabel: '',
      baseredirectURL: '',
      baseOpenInNewWindow: '',
      basetagDatas: {},
      basetagDatasGS: {},
      eventProjectDataLayer: {},
      tabIndex: null,
      tabValue: null,
      areaValue: true,
      tabRetailerList: [],
      extraParams: this.initialExtraParams,
      retailerCount: 0,
    };
  },
  mounted() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    this.displayFirstShop();
  },
  created() {
    if (this.commerceData.CountryList.length !== 0) {
      this.tabEnable(this.commerceData.CountryList[0], 0);
    }
    eventBus.on('rfp-mctb-optional-popup-enable', () => {
      this.expandPanel = true;
    });
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
  },
  methods: {
    pageRedirectUrl(
      redirectURL,
      OpenInNewWindow,
      standardTagsString,
      gsTagsString,
      pageRedirectUrls,
      autoValue,
    ) {
      this.buyMessage = pageRedirectUrls;
      this.baseredirectURL = redirectURL;
      this.baseOpenInNewWindow = OpenInNewWindow;
      if (standardTagsString) {
        eventBus.emit('rfp-mctb-datalayer-event-new');
        let tags = {};

        try {
          tags = JSON.parse(standardTagsString);
        } catch (e) {
          console.error(
            'error/rfp-mctb-pop-up-action-mode#pageRedirectUrl: Standard (GA) tag parsing failed',
            e,
          );
        }

        if (this.componentDiffs && Object.keys(this.eventProjectDataLayer).length > 0) {
          // Object.entries(this.eventProjectDataLayer).reduce((acc, [key, value]) => {
          //   acc[key] = value;
          //   return acc;
          // }, tags);

          for (var propName in this.eventProjectDataLayer) {
            tags[propName] = this.eventProjectDataLayer[propName];
          }
        }

        this.basetagDatas = tags;
      }
      if (gsTagsString) {
        try {
          this.basetagDatasGS = JSON.parse(gsTagsString);
        } catch (e) {
          console.error(
            'error/rfp-mctb-pop-up-action-mode#pageRedirectUrl: GRIDSUM tag parsing failed',
            e,
          );
        }
      }

      if (!this.enableBuynowRetailers && autoValue) {
        this.buyNowRetailers();
      }
    },
    switchPanel() {
      eventBus.emit('rfp-optional-popup-close');
    },
    shiftTabKeyupEvent() {
      this.shiftAndTabHappened = true;
    },
    buyNowRetailers() {
      eventBus.emit('rfpTaggingFoundation', {
        data: window.dataLayer ? this.basetagDatas : this.basetagDatasGS,
        values: {
          productName: this.productname,
          productId: this.productids,
          retailerName: this.buyMessage,
        },
        extraParams: this.extraParams,
        service: window.dataLayer ? ServiceType.GA : ServiceType.GSQ,
      });
      const target = this.baseOpenInNewWindow === true ? '_blank' : '_self';
      window.open(this.baseredirectURL, target);
    },
    displayFirstShop() {
      /**
       * The Document method querySelector() returns the first Element within the document that
       * matches the specified selector, or group of selectors. If no matches are found, null is returned.
       *
       * See: https://developer.mozilla.org/en-US/docs/Web/API/Document/querySelector
       */
      if (this.enableBuynowRetailers) {
        document.querySelector('.rfp-mctb-commerceConnector__radioLabel')?.click();
      }
    },
    tabEnable(item, index) {
      this.tabRetailerList = [];
      for (const retailerList of this.commerceData.Product.Retailers) {
        retailerList.Country === item.Name && this.tabRetailerList.push(retailerList);
      }
      this.tabIndex = index;
      this.tabValue = item;
      this.displayFirstShop();
      setTimeout(() => {
        this.displayFirstShop();
      }, 1000);
    },
  },
};
</script>
